module.exports = __webpack_public_path__ + "img/chinesecompany144.9906da42.png";